module.exports = __webpack_public_path__ + "img/phone-call.48288b02.svg";